// extracted by mini-css-extract-plugin
export default {"root":"category-form-module_root-RyplO"};